import React from 'react';

interface ProgressBarProps {
  filled: number;
  total: number;
  status: 'new' | 'filled' | 'rejected' | 'partially_filled';
}

export default function ProgressBar({ filled, total, status }: ProgressBarProps) {
  const percentage = total > 0 ? Math.min(100, Math.max(0, (filled / total) * 100)) : 0;
  
  const statusColors: Record<string, string> = {
    'new': '#3b82f6',
    'partially_filled': '#f59e0b',
    'filled': '#10b981',
    'rejected': '#ef4444'
  };
  
  const color = statusColors[status] || '#94a3b8';
  
  return (
    <div style={{ 
      width: '100%', 
      height: 6, 
      backgroundColor: '#1e293b', 
      borderRadius: 3,
      overflow: 'hidden',
      position: 'relative'
    }}>
      <div
        style={{
          width: `${percentage}%`,
          height: '100%',
          backgroundColor: color,
          transition: 'width 0.3s ease',
          borderRadius: 3
        }}
      />
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: 9,
        color: '#94a3b8',
        fontWeight: 600,
        textShadow: '0 0 2px rgba(0,0,0,0.8)'
      }}>
        {percentage.toFixed(0)}%
      </div>
    </div>
  );
}

